const initialState = {
  required: false
}

export default function accommodation(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_ACCOMMODATION_DETAILS':
      var change = action.change;
      // if we change to not required, discard all other details
      if (change.required && change.required == 0) {
        return action.change;
      }
      return Object.assign({}, state, action.change);

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/event_render/reducers/accommodation.js